<template>
  <div class="container page" style="background-color: #1f1c1f">
    <van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
    </van-nav-bar>

    <div class="header-info">
      <p class="title">{{ $t("recharge.curr_balance") }}(USDT)</p>
      <p class="value">{{ balance }}</p>
    </div>

    <div class="recharge-content">
      <van-form @submit="onSubmit">
        <div class="form-item">
          <div class="form-item-title">
            {{ $t("recharge.pay_way") || "支付方式" }}
          </div>
          <van-radio-group
            v-model="pay_way"
            direction="horizontal"
            class="custom-radio"
          >
            <van-radio name="TRC20">TRC20</van-radio>
            <van-radio name="ERC20">ERC20</van-radio>
          </van-radio-group>
        </div>

        <div class="address-box">
          <div class="form-item-title">
            {{ $t("recharge.recharge_addr") || "充值地址" }}
          </div>
          <div class="addr-display">
            <span class="addr-text">{{ cryptoAddress }}</span>
            <van-button
              size="small"
              type="info"
              @click="copyAddress"
              class="copy-btn"
            >
              {{ $t("recharge.copy") || "复制" }}
            </van-button>
          </div>
          <p class="tip-text">
            * {{ $t("recharge.min_tip") || "请务必核对协议，转错账概不负责" }}
          </p>
        </div>

        <div class="form-item">
          <div class="form-item-title">
            {{ $t("recharge.input_money") }} (USDT)
          </div>
          <van-field
            v-model="money"
            type="number"
            name="money"
            :placeholder="$t('recharge.input_money') || '请输入充值金额'"
            autocomplete="off"
          />
        </div>

        <div class="form-item">
          <div class="form-item-title">
            {{ $t("recharge.zjmm") || "资金密码" }}
          </div>
          <van-field
            v-model="paypassword"
            :placeholder="$t('recharge.input_zjmm') || '请输入资金密码'"
          />
        </div>

        <div style="margin: 32px 16px">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="submit-btn"
          >
            {{ $t("recharge.submit") || "提交" }}
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Form } from "vant";
import { Field } from "vant";
import { RadioGroup, Radio } from "vant";
Vue.use(Form).use(Field).use(RadioGroup).use(Radio);
export default {
  data() {
    return {
      balance: 0,
      pay_way: "TRC20", // 默认协议
      money: "",
      txid: "", // 交易流水号
      cryptoAddress: "Txxxxxxxxxxxxxxxxxxxxxxxxx", // 应该从后端接口获取
      personalreport: {},
      paypassword: null,
    };
  },
  mounted() {
    this.balance = this.$route.params.balance || 0;
    this.getAddress(); // 页面加载获取充值地址
  },
  methods: {
    back() {
      window.history.back();
    },
    // 获取后端配置的充值地址
    getAddress() {
      this.$http
        .get("get_recharge_address", { params: { type: this.pay_way } })
        .then((res) => {
          if (res.code === 200) {
            this.cryptoAddress = res.data.address;
          }
        });
    },
    // 复制地址到剪切板
    copyAddress() {
      const input = document.createElement("input");
      input.setAttribute("value", this.cryptoAddress);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        this.$toast(this.$t("recharge.copy_success") || "复制成功");
      }
      document.body.removeChild(input);
    },
    onSubmit() {
      if (this.money <= 0) {
        this.$toast(this.$t("reservation.money_err"));
        return;
      }
      if (!this.txid && this.pay_way !== "Mexicopay") {
        this.$toast(this.$t("recharge.txid_required") || "请输入交易哈希");
        return;
      }

      this.$http({
        method: "post",
        url: "recharge",
        data: {
          pay_way: this.pay_way,
          money: this.money,
          txid: this.txid,
          address: this.cryptoAddress,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg || "提交成功，请等待审核");
          this.$router.push("/RechargeRecord"); // 跳转到记录页
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  watch: {
    // 切换协议时重新获取地址
    pay_way() {
      this.getAddress();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.header-info {
  background: linear-gradient(135deg, #e6c3a1, #7e5678);
  padding: 40px 0;
  text-align: center;
  color: #fff;
  .title {
    font-size: 28px;
    opacity: 0.9;
  }
  .value {
    font-size: 60px;
    font-weight: bold;
    margin-top: 10px;
  }
}

::v-deep .van-radio__icon {
  font-size: 32px;
}
::v-deep .van-button--small {
  font-size: 28px;
}

.recharge-content {
  padding: 20px 30px;
  background: #1f1c1f;
}

.form-item-title {
  font-size: 30px;
  color: #e7b486;
  margin-bottom: 15px;
  margin-top: 30px;
}

/* 地址展示盒 */
.address-box {
  background: #2a2a2a;
  padding: 25px;
  border-radius: 15px;
  border: 1px dashed #766350;
  margin-top: 20px;

  .addr-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #1a1a1a;
    padding: 15px;
    border-radius: 8px;

    .addr-text {
      color: #f3c7a2;
      font-size: 24px;
      word-break: break-all;
      margin-right: 10px;
    }
  }

  .tip-text {
    font-size: 22px;
    color: #ff4d4f;
    margin-top: 10px;
  }
}

.custom-radio {
  margin-bottom: 20px;
  /deep/ .van-radio__label {
    color: #ccc;
    font-size: 28px;
  }
}

/* 输入框样式重写 */
/deep/ .van-cell {
  background: #2a2a2a;
  border-radius: 10px;
  border: 1px solid #444;
  padding: 20px;
  .van-field__control {
    color: #f3c7a2;
    font-size: 32px;
  }
}

.submit-btn {
  background: linear-gradient(90deg, #fde3ca, #e7b486);
  border: none;
  color: #68302c !important;
  font-weight: bold;
  height: 90px;
  font-size: 32px;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.5);
  }
  ::v-deep .van-nav-bar {
    height: 48px;
    line-height: 48px;
  }
  .header-info {
    background: linear-gradient(135deg, #e6c3a1, #7e5678);
    padding: 20px 0;
    text-align: center;
    color: #fff;
    .title {
      font-size: 16px;
      opacity: 0.9;
    }
    .value {
      font-size: 30px;
      font-weight: bold;
      margin-top: 10px;
    }
  }

  ::v-deep .van-radio__icon {
    font-size: 14px;
  }
  ::v-deep .van-button--small {
    font-size: 14px;
  }

  .recharge-content {
    padding: 20px 30px;
    background: #1f1c1f;
  }

  .form-item-title {
    font-size: 16px;
    color: #e7b486;
    margin-bottom: 15px;
    margin-top: 10px;
  }

  /* 地址展示盒 */
  .address-box {
    background: #2a2a2a;
    padding: 12px;
    border-radius: 15px;
    border: 1px dashed #766350;
    margin-top: 10px;

    .addr-display {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #1a1a1a;
      padding: 5px 10px;
      border-radius: 8px;

      .addr-text {
        color: #f3c7a2;
        font-size: 12px;
        word-break: break-all;
        margin-right: 10px;
      }
    }

    .tip-text {
      font-size: 12px;
      color: #ff4d4f;
      margin-top: 10px;
    }
  }

  .custom-radio {
    margin-bottom: 10px;
    /deep/ .van-radio__label {
      color: #ccc;
      font-size: 14px;
    }
  }

  ::v-deep .van-button--small {
    height: 36px;
  }

  /* 输入框样式重写 */
  /deep/ .van-cell {
    background: #2a2a2a;
    border-radius: 10px;
    border: 1px solid #444;
    padding: 5px 10px;
    .van-field__control {
      color: #f3c7a2;
      font-size: 16px;
    }
  }

  .submit-btn {
    background: linear-gradient(90deg, #fde3ca, #e7b486);
    border: none;
    color: #68302c !important;
    font-weight: bold;
    height: 48px;
    font-size: 16px;
  }
}
</style>
